import { adminState, getApi, http, adminGet, adminDelete, adminPost, adminPut } from './useAdminCore';
// ==================== Factoids ====================
function getFactoids(onSuccess = null) {
    adminState.factoidLoading = true;
    adminState.factoidError = null;
    adminGet("/Factoids", (result) => {
        adminState.factoids = result;
        adminState.factoidLoading = false;
        if (onSuccess)
            onSuccess(result);
    });
}
function createFactoid(factoidData, onSuccess = null) {
    adminPost('/Factoids', factoidData, (data) => {
        getFactoids();
        if (onSuccess)
            onSuccess(data);
    }, (error) => {
        adminState.factoidError = 'Failed to create factoid';
    });
}
function updateFactoid(id, factoidData, onSuccess = null) {
    adminPut('/Factoids/' + id, factoidData, (data) => {
        getFactoids();
        if (onSuccess)
            onSuccess(data);
    }, () => {
        adminState.factoidError = 'Failed to update factoid';
    });
}
function deleteFactoid(id, onSuccess = null) {
    http().delete(getApi() + '/Factoids/' + id)
        .then((response) => {
        getFactoids();
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch(() => {
        adminState.factoidError = 'Failed to delete factoid';
    });
}
// ==================== Sources ====================
function getSources(onSuccess = null) {
    adminState.sourcesLoading = true;
    adminState.sourcesError = null;
    adminGet("/Sources", (result) => {
        adminState.sources = result;
        adminState.sourcesLoading = false;
        if (onSuccess)
            onSuccess(result);
    });
}
function createSource(sourceData, onSuccess = null) {
    adminPost('/Sources', sourceData, (data) => {
        getSources();
        if (onSuccess)
            onSuccess(data);
    }, () => {
        adminState.sourcesError = 'Failed to create source';
    });
}
function updateSource(id, sourceData, onSuccess = null) {
    adminPut('/Sources/' + id, sourceData, (data) => {
        getSources();
        if (onSuccess)
            onSuccess(data);
    }, () => {
        adminState.sourcesError = 'Failed to update source';
    });
}
function deleteSource(id, onSuccess = null) {
    http().delete(getApi() + '/Sources/' + id)
        .then((response) => {
        getSources();
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch(() => {
        adminState.sourcesError = 'Failed to delete source';
    });
}
function testSource(sourceData, onSuccess = null, onError = null) {
    const params = new URLSearchParams({
        pageUrl: sourceData.pageUrl,
        acceptCookiesButton: sourceData.acceptCookiesButton || '',
        contentSelector: sourceData.contentSelector
    });
    http().get(getApi() + '/Page?' + params.toString())
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error testing source:', error);
        if (onError)
            onError(error.message || 'Failed to fetch page content');
    });
}
// ==================== Guides ====================
function getGuides(onSuccess = null) {
    adminState.guidesLoading = true;
    adminState.guidesError = null;
    adminGet("/Plans", (result) => {
        adminState.guides = result;
        adminState.guidesLoading = false;
        if (onSuccess)
            onSuccess(result);
    });
}
function createGuide(guideData, onSuccess = null, onError = null) {
    adminPost('/Plans', guideData, (data) => {
        getGuides();
        if (onSuccess)
            onSuccess(data);
    }, (error) => {
        const errorMsg = 'Failed to create guide';
        adminState.guidesError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
function updateGuide(id, guideData, onSuccess = null, onError = null) {
    adminPut('/Plans/' + id, guideData, (data) => {
        getGuides();
        if (onSuccess)
            onSuccess(data);
    }, () => {
        const errorMsg = 'Failed to update guide';
        adminState.guidesError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
function deleteGuide(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/Plans/' + id)
        .then((response) => {
        getGuides();
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch(() => {
        const errorMsg = 'Failed to delete guide';
        adminState.guidesError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
// ==================== FAQs ====================
function getFaqs(onSuccess = null) {
    adminState.faqLoading = true;
    adminState.faqError = null;
    adminGet("/Faq", (result) => {
        adminState.faqs = result;
        adminState.faqLoading = false;
        if (onSuccess)
            onSuccess(result);
    });
}
function createFaq(faqData, onSuccess = null, onError = null) {
    adminPost('/Faq', faqData, (data) => {
        getFaqs();
        if (onSuccess)
            onSuccess(data);
    }, (error) => {
        const errorMsg = 'Failed to create FAQ';
        adminState.faqError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
function updateFaq(id, faqData, onSuccess = null, onError = null) {
    adminPut('/Faq/' + id, faqData, (data) => {
        getFaqs();
        if (onSuccess)
            onSuccess(data);
    }, () => {
        const errorMsg = 'Failed to update FAQ';
        adminState.faqError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
function deleteFaq(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/Faq/' + id)
        .then((response) => {
        getFaqs();
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch(() => {
        const errorMsg = 'Failed to delete FAQ';
        adminState.faqError = errorMsg;
        if (onError)
            onError(errorMsg);
    });
}
// ==================== Walkthroughs ====================
function getWalkthroughs(onSuccess = null) {
    adminGet("/CMS/Walkthroughs", onSuccess);
}
function createWalkthrough(walkthroughData, onSuccess = null, onError = null) {
    adminPost('/CMS/Walkthroughs', walkthroughData, onSuccess, (error) => {
        if (onError)
            onError('Failed to create walkthrough');
    });
}
function updateWalkthrough(id, walkthroughData, onSuccess = null, onError = null) {
    adminPut('/CMS/Walkthroughs/' + id, walkthroughData, onSuccess, (error) => {
        if (onError)
            onError('Failed to update walkthrough');
    });
}
function deleteWalkthrough(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/CMS/Walkthroughs/' + id)
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error deleting walkthrough:', error);
        if (onError)
            onError('Failed to delete walkthrough');
    });
}
// ==================== Quizzes ====================
function getQuizzes(onSuccess = null, onError = null) {
    http().get(getApi() + '/Quizzes?onlyTodaysQuizzes=false&todaysQuestionsOnly=false&tomorrowsQuestionsOnly=false')
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error fetching quizzes:', error);
        if (onError)
            onError('Failed to fetch quizzes');
    });
}
function createQuiz(quizData, onSuccess = null, onError = null) {
    adminPost('/Quizzes', quizData, onSuccess, (error) => {
        if (onError)
            onError('Failed to create quiz');
    });
}
function updateQuiz(id, quizData, onSuccess = null, onError = null) {
    adminPut('/Quizzes/' + id, quizData, onSuccess, (error) => {
        if (onError)
            onError('Failed to update quiz');
    });
}
function deleteQuiz(id, onSuccess = null, onError = null) {
    http().delete(getApi() + '/Quizzes/' + id)
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error deleting quiz:', error);
        if (onError)
            onError('Failed to delete quiz');
    });
}
function resetQuizDates(id, startDate, secsInterval, onSuccess = null, onError = null) {
    const params = new URLSearchParams({
        secsInterval: String(secsInterval),
        startDate: startDate
    });
    adminPost('/Quizzes/' + id + '/ResetDateRequests_TEST?' + params.toString(), null, onSuccess, (error) => {
        if (onError)
            onError('Failed to reset quiz dates');
    });
}
// ==================== Policy Sections (CMS Configs) ====================
function getConfigFiles(onSuccess = null, onError = null) {
    http().get(getApi() + '/CMS/Configs')
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error fetching config files:', error);
        if (onError)
            onError('Failed to load config files');
    });
}
function getConfigFileContent(fileName, onSuccess = null, onError = null) {
    http().get(getApi() + '/CMS/Configs/' + fileName)
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error fetching config file content:', error);
        if (onError)
            onError('Failed to load file content');
    });
}
function saveConfigFile(fileName, base64Content, onSuccess = null, onError = null) {
    http().put(getApi() + '/CMS/Configs/' + fileName, `"${base64Content}"`, {
        headers: { 'Content-Type': 'application/json' },
        transformRequest: [(data) => data]
    })
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error saving config file:', error);
        if (onError)
            onError('Failed to save file');
    });
}
function deleteConfigFile(fileName, onSuccess = null, onError = null) {
    http().delete(getApi() + '/CMS/Configs/' + fileName)
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error deleting config file:', error);
        if (onError)
            onError('Failed to delete file');
    });
}
// ==================== CMS Files ====================
function getFiles(onSuccess = null, onError = null) {
    http().get(getApi() + '/CMS/Files?ordered=true')
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error fetching files:', error);
        if (onError)
            onError('Failed to load file list');
    });
}
function uploadFileChunk(base64Content, fileName, chunkIndex, totalChunks, uploadId, onSuccess = null, onError = null) {
    const payload = {
        content: base64Content,
        fileName: fileName,
        chunkIndex: chunkIndex,
        totalChunks: totalChunks,
        UploadId: uploadId
    };
    adminPost('/CMS/Files/UploadRequests', payload, onSuccess, (error) => {
        if (onError)
            onError('Failed to upload file chunk');
    });
}
function deleteFile(fileName, onSuccess = null, onError = null) {
    http().delete(getApi() + '/CMS/Files/' + fileName + '?file=' + fileName)
        .then((response) => {
        if (onSuccess)
            onSuccess(response.data);
    })
        .catch((error) => {
        console.error('Error deleting file:', error);
        if (onError)
            onError('Failed to delete file');
    });
}
// ==================== Email Templates ====================
function getEmailTemplates(onSuccess = null) {
    adminState.emailTemplatesLoading = true;
    adminState.emailTemplatesError = null;
    adminGet('/Notifications/EmailTemplates', (result) => {
        adminState.emailTemplates = result;
        adminState.emailTemplatesLoading = false;
        if (onSuccess)
            onSuccess(result);
    });
}
function createEmailTemplate(templateData, onSuccess = null) {
    adminPost('/Notifications/EmailTemplates', templateData, (data) => {
        getEmailTemplates();
        if (onSuccess)
            onSuccess(data);
    }, () => {
        adminState.emailTemplatesError = 'Failed to create email template';
    });
}
function updateEmailTemplate(id, templateData, onSuccess = null) {
    adminPut('/Notifications/EmailTemplates/' + id, templateData, (data) => {
        getEmailTemplates();
        if (onSuccess)
            onSuccess(data);
    }, () => {
        adminState.emailTemplatesError = 'Failed to update email template';
    });
}
function deleteEmailTemplate(id, onSuccess = null) {
    adminDelete('/Notifications/EmailTemplates/' + id, (data) => {
        getEmailTemplates();
        if (onSuccess)
            onSuccess(data);
    });
}
function sendEmail(request, onSuccess = null, onError = null) {
    adminPost('/Notifications/AdminSendEmailRequests', request, onSuccess, onError);
}
export { 
// Factoids
getFactoids, createFactoid, updateFactoid, deleteFactoid, 
// Sources
getSources, createSource, updateSource, deleteSource, testSource, 
// Guides
getGuides, createGuide, updateGuide, deleteGuide, 
// FAQs
getFaqs, createFaq, updateFaq, deleteFaq, 
// Walkthroughs
getWalkthroughs, createWalkthrough, updateWalkthrough, deleteWalkthrough, 
// Quizzes
getQuizzes, createQuiz, updateQuiz, deleteQuiz, resetQuizDates, 
// Config files
getConfigFiles, getConfigFileContent, saveConfigFile, deleteConfigFile, 
// CMS Files
getFiles, uploadFileChunk, deleteFile, 
// Email Templates
getEmailTemplates, createEmailTemplate, updateEmailTemplate, deleteEmailTemplate, sendEmail, };
